import { GridCellProps } from '@progress/kendo-react-grid';
import { format } from 'date-fns';
import { useCallback } from 'react';
import GridCellBase from 'src/components/GridCellBase';
import useInvoiceScanManager from 'src/hooks/useInvoiceScanManager';

const UploadedOnCell = (props: GridCellProps) => {
  const date = props.dataItem.creationDate;
  const dateTime = new Date(date);
  const formattedDate = format(dateTime, 'MM/dd/yyyy hh:mm a');
  const { handleCellClick } = useInvoiceScanManager();

  const handleClick = useCallback(() => {
    handleCellClick(props.dataItem.attachId);
  }, [handleCellClick, props.dataItem.attachId]);

  return (
    <GridCellBase
      {...props}
      rowSelectionEnabled={false}
      title={formattedDate}
      onClick={handleClick}
    >
      {formattedDate}
    </GridCellBase>
  );
};

export default UploadedOnCell;
